import { msg } from '@lingui/core/macro'
import { entityId } from '@pkg/db/schema'
import { defineEnum } from '@pkg/shared/utils/enum-builder'
import dayjs from 'dayjs'
import { z } from 'zod'
import { PatientRelation } from './PatientRelation'

export const MobilityEnum = defineEnum({
  MOBIL: { label: msg`Mobil`, description: msg`Selbstständig auch außerhalb des Wohnt- oder Stationsbereichs.` },
  MOBIL_AT_HOME: { label: msg`Mobil zu Hause`, description: msg`Selbstständig nur im Wohn- oder Stationsbereich.` },
  IMMOBIL: { label: msg`Immobil`, description: msg`Keine selbstständige Fortbewegung möglich.` },
})

export type MobilityType = typeof MobilityEnum.$.Type

export const PatientMobilityId = entityId('patientMobility')

export type PatientMobilityIdType = typeof PatientMobilityId.Type

export const PatientMobilityRelationSchema = PatientRelation.extend({
  id: PatientMobilityId.schema,
  mobility: z.enum(MobilityEnum.$.zodEnum()),
  activeFrom: z.iso.date().default(() => dayjs().format('YYYY-MM-DD')),
})

export type PatientMobilityRelation = z.infer<typeof PatientMobilityRelationSchema>
